// src/components/DesktopSidebar.js
import React, { useContext, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiHome, FiMic, FiSettings, FiUser } from 'react-icons/fi';
import styles from './DesktopSidebarLayout.module.css';
import { UserContext } from '../App';
import { hasRoleEntitlement, ROLE_ARTIST } from '../utils/roles';

export default function DesktopSidebar({ active = 'home', note = '' }) {
  const navigate = useNavigate();
  const appUser = useContext(UserContext);
  const displayName = useMemo(() => {
    const name = [appUser?.firstName, appUser?.lastName].filter(Boolean).join(' ').trim();
    return name || appUser?.email || 'Razzberry';
  }, [appUser?.firstName, appUser?.lastName, appUser?.email]);
  const links = [
    { key: 'home', label: 'Home', icon: FiHome, to: '/home' },
    { key: 'fan', label: 'Fan', icon: FiUser, to: '/fan' },
    ...(hasRoleEntitlement(appUser, ROLE_ARTIST) ? [{ key: 'artist', label: 'Creator', icon: FiMic, to: '/creator' }] : []),
  ];

  return (
    <aside className={styles.sidebar}>
      <div className={styles.brandBlock}>
        <img className={styles.brandLogo} src="/assets/razzberry-white-logo-200.png" alt="Razzberry" />
        <div className={styles.brandText}>
          <strong>Razzberry</strong>
          <span>{displayName}</span>
        </div>
      </div>
      <nav className={styles.sideNav}>
        {links.map(({ key, label, icon: Icon, to }) => (
          <button
            key={key}
            type="button"
            className={`${styles.sideLink} ${active === key ? styles.sideLinkActive : ''}`.trim()}
            onClick={() => navigate(to)}
          >
            <Icon />
            {label}
          </button>
        ))}
        <button
          type="button"
          className={`${styles.sideLink} ${active === 'settings' ? styles.sideLinkActive : ''}`.trim()}
          onClick={() => navigate('/fan/settings')}
        >
          <FiSettings />
          Settings
        </button>
      </nav>
      {note ? <div className={styles.sideNote}>{note}</div> : null}
    </aside>
  );
}
